app.provider("fullStoryService", [function () {
    this.$get = ["$q", function ($q) {
        var fs;
        if (window.FS) {
            // if FS has loaded fast enough it is already present on the window object
            fs = $q.when(window.FS);
        }
        else {
            // fullstory.js hasn't finished loading
            var defer = $q.defer();
            fs = defer.promise;
            // find script element and hook into onload
            var fsJs = Array.from(document.getElementsByTagName("script")).filter(s => s.src === "https://fullstory.com/s/fs.js")[0];
            fsJs.addEventListener("onload", () => {
                // by now script has loaded and window.FS should be available
                defer.resolve(window.FS);
            });
        }
        return fs;
    }];
}]);